export default "__VITE_ASSET__qjdyoP1n__"